import Login from './Login';
import Dashboard, { logoutAction } from './Dashboard';
import {
  createBrowserRouter,
  redirect,
  RouterProvider,
} from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import NotFound from './NotFound';

const router = createBrowserRouter([
  {
    path: '/',
    element: <Login />,
    loader: () => {
      const userData = JSON.parse(localStorage.getItem('user'));
      return userData ? redirect('/dashboard') : null;
    },
  },
  {
    path: 'dashboard',
    element: <Dashboard />,
    loader: () => {
      const userData = JSON.parse(localStorage.getItem('user'));
      if (!userData) toast.error('Nu esti autentificat!');
      return !userData ? redirect('/') : null;
    },
  },
  {
    path: 'logout',
    action: logoutAction,
  },
  {
    path: '*',
    element: <NotFound />,
  },
]);

function App() {
  return (
    <>
      <RouterProvider router={router} />
      <ToastContainer />
    </>
  );
}

export default App;
